export const guideTexts = {
  es: {
    badge: 'Guía gratuita en PDF',
    title: '¿Cuenta de Google Ads suspendida? Descarga nuestra guía gratis para desbloquearla',
    subtitle: 'Todo lo que necesitas saber antes de apelar una suspensión de Google Ads, explicado por especialistas en compliance.',
    bullets: [
      'Identificar el motivo real de la suspensión',
      'Preparar una apelación sólida paso a paso',
      'Evitar los errores que hacen rechazar una apelación',
    ],
    formTitle: 'Descarga la guía gratis',
    articleLink: 'Leer cómo recuperar una cuenta suspendida',
    fields: { first_name: 'Nombre', last_name: 'Apellidos', email: 'Email', phone: 'Teléfono', website: 'Sitio web', reason: 'Motivo de la suspensión', pdf_lang: 'Idioma del PDF' },
    reasonPlaceholder: 'Copia el mensaje de Google o explica qué ha pasado',
    consent: 'Acepto la política de privacidad y que Agencia PPC me contacte sobre mi cuenta.',
    privacy: 'Política de Privacidad',
    privacyUrl: '/es/privacidad',
    submit: 'Descargar la guía gratis',
    success: '¡Gracias! Tu descarga ha comenzado.',
    again: 'Descargar de nuevo',
    error: 'Ha ocurrido un error. Por favor, inténtalo de nuevo.',
  },
  fr: {
    badge: 'Guide PDF gratuit',
    title: 'Compte Google Ads suspendu ? Téléchargez notre guide gratuit pour le débloquer',
    subtitle: "Tout ce qu'il faut savoir avant de faire appel d'une suspension Google Ads, expliqué par des spécialistes de la conformité.",
    bullets: [
      'Identifier la vraie raison de la suspension',
      'Préparer un appel solide, étape par étape',
      'Éviter les erreurs qui font rejeter un appel',
    ],
    formTitle: 'Téléchargez le guide gratuit',
    articleLink: 'Lire comment récupérer un compte suspendu',
    fields: { first_name: 'Prénom', last_name: 'Nom', email: 'Email', phone: 'Téléphone', website: 'Site web', reason: 'Raison de la suspension', pdf_lang: 'Langue du PDF' },
    reasonPlaceholder: "Copiez le message de Google ou expliquez ce qui s'est passé",
    consent: "J'accepte la politique de confidentialité et d'être contacté par Agencia PPC au sujet de mon compte.",
    privacy: 'Politique de confidentialité',
    privacyUrl: '/fr/confidentialite',
    submit: 'Télécharger le guide gratuit',
    success: 'Merci ! Votre téléchargement a commencé.',
    again: 'Télécharger à nouveau',
    error: 'Une erreur est survenue. Veuillez réessayer.',
  },
  en: {
    badge: 'Free PDF guide',
    title: 'Google Ads account suspended? Download our free guide to get it back',
    subtitle: 'Everything you need to know before appealing a Google Ads suspension, explained by compliance specialists.',
    bullets: [
      'Identify the real reason for the suspension',
      'Prepare a strong appeal, step by step',
      'Avoid the mistakes that get appeals rejected',
    ],
    formTitle: 'Download the free guide',
    articleLink: 'Read how to recover a suspended account',
    fields: { first_name: 'First name', last_name: 'Last name', email: 'Email', phone: 'Phone', website: 'Website', reason: 'Suspension reason', pdf_lang: 'PDF language' },
    reasonPlaceholder: "Paste Google's message or explain what happened",
    consent: 'I accept the privacy policy and to be contacted by Agencia PPC about my account.',
    privacy: 'Privacy Policy',
    privacyUrl: '/en/privacy',
    submit: 'Download the free guide',
    success: 'Thank you! Your download has started.',
    again: 'Download again',
    error: 'Something went wrong. Please try again.',
  },
};
